export const generatePageArray = (start: number, end: number) => {
    return [...Array(end - start + 1).keys()].map((i) => i + start);
};